import PropTypes from 'prop-types';

import styles from './ActionMenuItem.module.scss';

const ActionMenuItem = ({ children, onClick, disabled, ...props }) => {
    const handleClick = (e) => {
        if (disabled) {
            e.stopPropagation();
            return;
        }
        onClick?.(e);
    };

    return (
        <div
            className={`${styles.menuItem} ${disabled ? styles.disabled : ''}`}
            onClick={handleClick}
            role="menuitem"
            aria-disabled={disabled}
            {...props}
        >
            {children}
        </div>
    );
};

ActionMenuItem.propTypes = {
    children: PropTypes.any,
    onClick: PropTypes.func,
    disabled: PropTypes.bool
};

export default ActionMenuItem;
